import script from "./CardPokemonSelected.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPokemonSelected.vue?vue&type=script&setup=true&lang=js"

import "./CardPokemonSelected.vue?vue&type=style&index=0&id=b479aa14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b479aa14"]])

export default __exports__